import { useState } from "react";
import { FaCode, FaFileAlt, FaFolderOpen, FaTerminal } from "react-icons/fa";
import { AppCodeBlock } from "../../../../../_CORE/APP/Templates/_UI/CodeBlock/_index";
import {
    ReadOnlyInfo,
    ReadOnlyModalShell,
    ReadOnlySectionNav,
} from "../../../../../_CORE/APP/Templates/_UI/ReadOnly/_index";
import { OPTIONS_SNIPPET_TARGET, OPTIONS_SNIPPET_KIND, onFindOptionLabel } from "../../../_Catalogs.Views";

const hasText = (value) => String(value ?? "").trim().length > 0;
const lineCount = (value) => hasText(value) ? String(value).split("\n").length : 0;

export const SnippetReadModal = ({ isOpen, snippet, onClose }) => {
    const [useActiveSection, setActiveSection] = useState(null);

    if (!snippet) return null;

    const SECTION_PREFIX = `snippet-read-${snippet.id}`;
    const sectionDomId = (id) => `${SECTION_PREFIX}-${id}`;

    const SECTIONS = [
        { id: "description", label: "Descripción", icon: <FaFileAlt />, isVisible: hasText(snippet.description) },
        { id: "directory", label: "Directorio", icon: <FaFolderOpen />, isVisible: hasText(snippet.workingDirectory) },
        { id: "code", label: "Código", icon: <FaCode />, count: lineCount(snippet.code), isVisible: hasText(snippet.code) },
    ].filter((section) => section.isVisible);

    const ACTIVE_SECTION = SECTIONS.some((section) => section.id === useActiveSection)
        ? useActiveSection
        : (SECTIONS[0]?.id ?? null);

    const onGoToSection = (id) => {
        setActiveSection(id);
        document.getElementById(sectionDomId(id))?.scrollIntoView({ behavior: "smooth", block: "start" });
    };

    const META = (
        <>
            <ReadOnlySectionNav
                items={SECTIONS}
                heading="En este script"
                activeId={ACTIVE_SECTION}
                onSelect={onGoToSection}
            />

            <section className="LStudio__readonly_meta_section">
                <strong>Script</strong>
                <h3>{snippet.title}</h3>
                <p>{onFindOptionLabel(OPTIONS_SNIPPET_TARGET, snippet.target)} · {onFindOptionLabel(OPTIONS_SNIPPET_KIND, snippet.kind)}</p>
            </section>

            <section className="LStudio__readonly_meta_section">
                <ReadOnlyInfo createdAt={snippet.createdAt} updatedAt={snippet.updatedAt} />
            </section>
        </>
    );

    return (
        <ReadOnlyModalShell
            isOpen={isOpen}
            onClose={onClose}
            icon={<FaTerminal />}
            title={snippet.title || "Script"}
            currentLabel="Script"
            meta={META}
        >
            <article className="LStudio__readonly_document">
                <div className="LStudio__readonly_document_title">
                    <span><FaTerminal /></span>
                    <div>
                        <small>{onFindOptionLabel(OPTIONS_SNIPPET_KIND, snippet.kind)}</small>
                        <h1>{snippet.title}</h1>
                    </div>
                </div>

                {hasText(snippet.description) && (
                    <section id={sectionDomId("description")} className="LStudio__readonly_section">
                        <strong>Descripción</strong>
                        <p>{snippet.description}</p>
                    </section>
                )}

                {hasText(snippet.workingDirectory) && (
                    <section id={sectionDomId("directory")} className="LStudio__readonly_section">
                        <strong><FaFolderOpen /> Directorio de trabajo</strong>
                        <p>{snippet.workingDirectory}</p>
                    </section>
                )}

                {hasText(snippet.code) && (
                    <section id={sectionDomId("code")} className="LStudio__readonly_section LStudio__readonly_section--code">
                        <strong><FaCode /> Código / comando</strong>
                        <AppCodeBlock
                            code={snippet.code}
                            language={snippet.language}
                            title={snippet.language || "Código"}
                            isPretty={false}
                            maxLines={36}
                        />
                    </section>
                )}
            </article>
        </ReadOnlyModalShell>
    );
};
